var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      staticClass: "case-time_clock",
      attrs: {
        "data-is-working": String(_vm.context.Service.isWorking),
        "data-disabled": String(_vm.context.Service.isEnded),
      },
    },
    [
      _c("span", { staticClass: "rec-light" }, [
        _c("i", { staticClass: "case-time_working-icon" }),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.$t("case_time.rec")))]),
      ]),
      _vm.days
        ? _c("span", { staticClass: "tick-days" }, [
            _vm._v(
              " " + _vm._s(_vm.$t("case_time.days", { num: _vm.days })) + " "
            ),
          ])
        : _vm._e(),
      _c("span", { staticClass: "tick" }, [_vm._v(_vm._s(_vm.tickTime))]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }